export { allNetworks, availableNetworks, selectableNetworks } from '@polkadot/networks';
